import { axiosApiClient } from "..";
import { handleError } from "../../utils/errors";

class ViewTrackingService {
  trackBandView = async (bandId) => {
    try {
      const response = await axiosApiClient.post(`/bands/${bandId}/track-view`);

      if (response.status !== 200) {
        throw new Error();
      }
      return response.data;
    } catch (error) {
      throw handleError(error);
    }
  };

  getBandViewStats = async (bandId) => {
    try {
      const response = await axiosApiClient.get(`/bands/${bandId}/view-stats`);

      if (response.status !== 200) {
        throw new Error();
      }
      return response.data;
    } catch (error) {
      throw handleError(error);
    }
  };

  getMostViewedBands = async ({ limit = 10, days = 30 } = {}) => {
    try {
      const response = await axiosApiClient.get(`/bands/most-viewed`, {
        params: {
          limit,
          days,
        },
      });

      if (response.status !== 200) {
        throw new Error();
      }
      return response.data;
    } catch (error) {
      throw handleError(error);
    }
  };
}

export default new ViewTrackingService();
